import { useQuery } from "@apollo/client";
import { useEffect, useMemo, useRef, useState } from "react";
import GetGatheringForFullPublicTopPhotosDocument from "src/api/graphql/__generated__/documents/GetGatheringForFullPublicTopPhotosDocument";
import { FullPublicPhotoFragmentFragment } from "src/api/graphql/__generated__/graphql";
import useStabilizedCallback from "src/hooks/useStabilizedCallback";

const useGatheringFullPublicTopPhotos = ({ gatheringId }: { gatheringId: string }) => {
	const { data, refetch } = useQuery(GetGatheringForFullPublicTopPhotosDocument, {
		fetchPolicy: "cache-first",
		variables: {
			input: {
				gatheringId,
			},
		},
	});
	const [initialLoading, setInitialLoading] = useState(true);
	const refreshingRef = useRef(false);
	useEffect(() => {
		refreshingRef.current = true;
		refetch({
			input: {
				gatheringId,
			},
		}).finally(() => {
			setInitialLoading(false);
		});
	}, [gatheringId, refetch]);

	const [refreshing, setRefreshing] = useState(false);
	const handleRefresh = useStabilizedCallback(async () => {
		if (refreshingRef.current) return;
		try {
			setRefreshing(true);
			refreshingRef.current = true;
			await refetch({
				input: {
					gatheringId,
				},
			});
		} finally {
			setRefreshing(false);
			refreshingRef.current = false;
		}
	}, [gatheringId, refetch]);
	const topPhotos = useMemo<FullPublicPhotoFragmentFragment[]>(() => {
		return data?.getGathering?.topPhotos?.payload ?? [];
	}, [data?.getGathering?.topPhotos?.payload]);

	return {
		refresh: handleRefresh,
		queryLoading: initialLoading,
		topPhotos,
		refreshing,
	};
};
export default useGatheringFullPublicTopPhotos;
